import Components from "slotworks/components/components";
import GameState from "slotworks/model/game-state";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import SlotDefinition from "slotworks/model/slot-definition";
import State from "slotworks/state-machine/states/state";
import Point from "slotworks/utils/geom/point";

export default class RecoverStickySymbols extends State {
    public onEnter() {
        const record = GameState.getCurrentGame().getFirstRecord();
        if (record instanceof SpinRecord) {
            const overlayGrid = record.overlayGrid;
            if (overlayGrid) {
                for (let reel = 0; reel < overlayGrid.length; reel++) {
                    for (let symbol = 0; symbol < overlayGrid[reel].length; symbol++) {
                        if (overlayGrid[reel][symbol]) {
                            const symbolId = overlayGrid[reel][symbol];
                            const symbolDef = SlotDefinition.getSymbolDefinition(symbolId);
                            if (symbolDef.sticky) {
                                Components.matrix.addStuckSymbolById(new Point(reel + 1, symbol + 1), symbolId);
                            }
                        }
                    }
                }
            }
        }

        this.complete();
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/state-machine/standard/states/recover-sticky-symbols.ts